import React from "react";
import useTranslation from "next-translate/useTranslation";
import { Controller } from "react-hook-form";
import { Switch } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/outline";
import classNames from "lib/classNames";

export default function Checkboxes({
  name,
  label,
  control,
  errors,
  options,
  labelDisplay,
  required = false,
}) {
  const { t } = useTranslation("common");

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { value, onChange } }) => (
        <div>
          <div
            className={
              labelDisplay === "invisible"
                ? "sr-only"
                : "inline-block mb-1 font-important font-medium uppercase text-sm"
            }
          >
            {label}
            {required && (
              <>
                {" "}
                <span className="text-primary">*</span>
              </>
            )}
          </div>
          <div className="flex flex-col gap-2">
            {Object.entries(options).map(([key, label]) => {
              const isChecked = value?.includes(key) || false;
              const changeHandler = () => {
                if (isChecked) {
                  onChange(value.filter((v) => v !== key));
                } else {
                  onChange(value ? [key, ...value] : [key]);
                }
              };

              return (
                <Switch.Group key={key}>
                  <div className="flex items-center gap-4">
                    <Switch
                      checked={isChecked}
                      onChange={changeHandler}
                      className="relative inline-flex p-1 transition-colors border border-primary bg-gray-100"
                    >
                      <CheckIcon
                        className={classNames(
                          "h-4 w-4 transition-colors",
                          isChecked ? "text-primary" : "text-transparent"
                        )}
                      />
                    </Switch>

                    <Switch.Label className="cursor-pointer">
                      <span>{label}</span>
                    </Switch.Label>
                  </div>
                </Switch.Group>
              );
            })}
          </div>
          {errors && (
            <p
              role="alert"
              className="block mt-1 text-sm text-red-500 font-semibold"
            >
              {errors.message}
            </p>
          )}
        </div>
      )}
      rules={{
        required: required ? t("form.required") : false,
      }}
    />
  );
}
